import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import { Trans } from "react-i18next";
import { withCookies } from "react-cookie";
import { toast } from 'react-toastify';
import {
  Grid,
  BarChart2,
  Bell,
  Truck,
  Calendar,
  FileText,
  Monitor,
  ShoppingBag,
  Package,
  Award,
  Share2,
  MessageSquare,
  Globe,
  MapPin,
  Layers,
  Briefcase,
  Mail,
  Image as ImageIcon,
  Map,
  Gift,
  Navigation,
  ShoppingCart,
  Users,
  MessageCircle,
  CreditCard,
  DollarSign,
  Percent,
  Settings,
  Activity,
  Zap,
  UserCheck,
} from "react-feather";

class Sidebar extends Component {
  state = {
    isLoggingOut: false
  };

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({ [menuState]: false });
    } else if (Object.keys(this.state).length === 0) {
      this.setState({ [menuState]: true });
    } else {
      Object.keys(this.state).forEach((i) => {
        this.setState({ [i]: false });
      });
      this.setState({ [menuState]: true });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    document.querySelector("#sidebar").classList.remove("active");
    Object.keys(this.state).forEach((i) => {
      this.setState({ [i]: false });
    });

    const dropdownPaths = [
      { path: "/add-caterory", state: "categoryMenuOpen" },
      { path: "/basic-ui", state: "regionMenuOpen" },
      { path: "/basic-ui", state: "regionMenuOpen" },
      { path: "/form-elements", state: "formElementsMenuOpen" },
      { path: "/tables", state: "tablesMenuOpen" },
      { path: "/icons", state: "iconsMenuOpen" },
      { path: "/charts", state: "chartsMenuOpen" },
      { path: "/user-pages", state: "userPagesMenuOpen" },
      { path: "/error-pages", state: "errorPagesMenuOpen" },
      { path: "/email-management", state: "emailsHistoryMenuOpen" },
      { path: "/documents", state: "documentsMenuOpen" },
      { path: "/invoice-app-documents", state: "documentsMenuOpen" },
    ];

    dropdownPaths.forEach((obj) => {
      if (this.isPathActive(obj.path)) {
        this.setState({ [obj.state]: true });
      }
    });
  }

  onClickSignOut = () => {
    if (this.state.isLoggingOut) return; // Prevent multiple clicks
    
    this.setState({ isLoggingOut: true });
    toast.info('Logging out...', { autoClose: 1000 });
    
    // Don't save URL on manual logout - user intentionally left the page
    // URL is only saved on session expiry (401) in axios interceptor
    sessionStorage.removeItem('redirectAfterLogin');
    sessionStorage.removeItem('redirectAttempts');
    sessionStorage.removeItem('lastAttemptedRedirect');
    
    const { cookies } = this.props;
    cookies.remove("user");
    
    // Show success message before redirecting
    toast.success('Logged out successfully', { autoClose: 1000 });
    
    // Small delay to show the toast
    setTimeout(() => {
      window.location.href = "/";
    }, 500);
  };

  render() {
    const data = '{"auth":"","email":"","name":"","role":"","id":""}';
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <div className="text-center sidebar-brand-wrapper d-flex align-items-center">
          <a className="sidebar-brand brand-logo" href="/dashboard">
            <img
              src={require("../../assets/images/logo/starn22_logo.png")}
              alt="logo"
            />
            <h2>Starn22</h2>{" "}
          </a>
          <a className="sidebar-brand brand-logo-mini pt-3" href="/dashboard">
            <img
              src={require("../../assets/images/logo/starn22_logo.png")}
              alt="logo"
            />
          </a>
        </div>
        {JSON.parse(this.props?.cookies?.cookies.user || data)?.role ===
          "admin" && (
          <ul className="nav">
            <li
              className={
                this.isPathActive("/dashboard") ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/dashboard">
                <Grid className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Dashboard</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/sales") ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/sales">
                <BarChart2 className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Sales</Trans>
                </span>
              </Link>
            </li>

            <li
              className={
                this.isPathActive("/order-reminders")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link className="nav-link" to="/order-reminders">
                <Bell className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Order Reminders</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/deliveries")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link className="nav-link" to="/view-deliveries">
                <Truck className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Deliveries</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/sessions") ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/view-sessions">
                <Calendar className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Session Managment</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/documents") ||
                this.isPathActive("/invoice-app-documents")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <div
                className={
                  this.state.documentsMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("documentsMenuOpen")}
                data-toggle="collapse"
              >
                <FileText className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Documents</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.documentsMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/documents")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/documents"
                    >
                      <Trans>Documents</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/invoice-app-documents")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/invoice-app-documents"
                    >
                      <Trans>Invoice App Docs</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>

            <li
              className={
                this.isPathActive("/view-pos") ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/view-pos">
                <Monitor className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>POS</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/view-store") ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/view-store">
                <ShoppingBag className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Store</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/warehouse") ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/view-warehouse">
                <Package className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Ware house Managment</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/program") ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/view-fidelity-program">
                <Award className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Fidelity program</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/program") ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/view-referral-program">
                <Share2 className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Referral Program</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/customer-interviews")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link className="nav-link" to="/customer-interviews">
                <MessageSquare className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Interviews</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/basic-ui") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.regionMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("regionMenuOpen")}
                data-toggle="collapse"
              >
                <Globe className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Region</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.regionMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-region")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-region"
                    >
                      <Trans>Region</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-new-region")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-new-region"
                    >
                      <Trans>Add new Region</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/basic-ui") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.locationMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("locationMenuOpen")}
                data-toggle="collapse"
              >
                <MapPin className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Location</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.locationMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-location")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-location"
                    >
                      <Trans>Location</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-new-location")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-new-location"
                    >
                      <Trans>Add new Location</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/category") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.categoryMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("categoryMenuOpen")}
                data-toggle="collapse"
              >
                <Layers className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Categories</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.categoryMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/product-categories")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/product-categories"
                    >
                      <Trans>Product Categories</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/producers") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.producersMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("producersMenuOpen")}
                data-toggle="collapse"
              >
                <Briefcase className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Producers</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.producersMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-producers")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-producers"
                    >
                      <Trans>View Producers</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-producers")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-producers"
                    >
                      <Trans>Add New Producers</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/view-emails-history")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <div
                className={
                  this.state.emailsHistoryMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("emailsHistoryMenuOpen")}
                data-toggle="collapse"
              >
                <Mail className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Emails Managment</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.emailsHistoryMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-emails-history")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-emails-history"
                    >
                      <Trans>Emails History</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-emails-cc-bcc")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-emails-cc-bcc"
                    >
                      <Trans>Emails CC BCC</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-templates")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-templates"
                    >
                      <Trans>Content Templates</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/email-management/users")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/email-management/users"
                    >
                      <Trans>Email Users</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/view-banners")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <div
                className={
                  this.state.bannersMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("bannersMenuOpen")}
                data-toggle="collapse"
              >
                <ImageIcon className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Banners</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.bannersMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-banners")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-banners"
                    >
                      <Trans>Banners</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-public-files")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-public-files"
                    >
                      <Trans>Public Files</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/tables") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.productsMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("productsMenuOpen")}
                data-toggle="collapse"
              >
                <Package className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Products</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.productsMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-promoted-product")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-promoted-product"
                    >
                      <Trans>Promoted Products</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-product")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-product"
                    >
                      <Trans>View Products</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-product")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-product"
                    >
                      <Trans>Add New Products</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/product-import-export")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/product-import-export"
                    >
                      <Trans>Import / Export</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/product-import-staging")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/product-import-staging"
                    >
                      <Trans>Imported Products (Staging)</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/tables") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.productsRegionMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("productsRegionMenuOpen")}
                data-toggle="collapse"
              >
                <Map className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Products in Region</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.productsRegionMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("view-productIn-region")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-productIn-region"
                    >
                      <Trans>View Products</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-productIn-region")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-productIn-region"
                    >
                      <Trans>Add New Products</Trans>
                    </Link>
                  </li>{" "}
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/tables") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.offersMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("offersMenuOpen")}
                data-toggle="collapse"
              >
                <Gift className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Offer</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.offersMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("view-offer")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-offer"
                    >
                      <Trans>View Offers</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-offer")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-offer"
                    >
                      <Trans>Add New Offer</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/coupon-codes")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/coupon-codes"
                    >
                      <Trans>Coupon Codes</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-gifts")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-gifts"
                    >
                      <Trans>Gifts</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-product-samples")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-product-samples"
                    >
                      <Trans>Tasting Samples</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/icons") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.routessMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("routessMenuOpen")}
                data-toggle="collapse"
              >
                <Navigation className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Routes</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.routessMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-delivery-day")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/delivery-groups"
                    >
                      View Delivery Groups
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-delivery-day")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-delivery-day"
                    >
                      View Routes
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("add-delivery-day")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-delivery-day"
                    >
                      Add new Delivery Day
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-holidays")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-holidays"
                    >
                      Holidays
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/icons") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.ordersMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("ordersMenuOpen")}
                data-toggle="collapse"
              >
                <ShoppingCart className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Order</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.ordersMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-order")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-order"
                    >
                      View Order
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/icons") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.reportsMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("reportsMenuOpen")}
                data-toggle="collapse"
              >
                <BarChart2 className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Reports</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.reportsMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-report")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-report"
                    >
                      View Reports
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-report")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-sales-report"
                    >
                      View Sales Dashboard
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/picking-list-history")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/picking-list-history"
                    >
                      Picking List History
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/charts") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.customersMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("customersMenuOpen")}
                data-toggle="collapse"
              >
                <Users className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Customers</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.customersMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-customers")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-customers"
                    >
                      View Customer
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/customer-sales")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/customer-sales"
                    >
                      Customer Sales
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/customer-purchase-pattern")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/customer-purchase-pattern"
                    >
                      <Trans>Purchase Pattern</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/deletion-requests")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/deletion-requests"
                    >
                      <Trans>Deletion Requests</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/notifications")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <div
                className={
                  this.state.notificationsMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("notificationsMenuOpen")}
                data-toggle="collapse"
              >
                <Bell className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Notifications</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.notificationsMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-notifications")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-notifications"
                    >
                      add Notifications
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-notifications")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-whatsapp"
                    >
                      Send Whatsapp
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-notifications")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-notifications"
                    >
                      View Notifications
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/contact") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.contactMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("contactMenuOpen")}
                data-toggle="collapse"
              >
                <MessageCircle className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Contact us</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.contactMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/whatsapp-customers")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/whatsapp-customers"
                    >
                      Whatsapp
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/sales-whatsapp")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/sales-whatsapp"
                    >
                      Sales Whatsapp
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/feedbacks")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/feedbacks"
                    >
                      Feedback
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/contact-customers")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/contact-customers"
                    >
                      Contact
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/issues")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/issues"
                    >
                      Issues
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/tasks-oversight")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/tasks-oversight"
                    >
                      Tasks
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/payments") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.payments ? "nav-link menu-expanded" : "nav-link"
                }
                onClick={() => this.toggleMenuState("payments")}
                data-toggle="collapse"
              >
                <CreditCard className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Payment Methods</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.payments}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-payment")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-payment"
                    >
                      View Payment Method
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-payment")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-payment"
                    >
                      Add Payment Method
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/icons") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.minOrderMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("minOrderMenuOpen")}
                data-toggle="collapse"
              >
                <DollarSign className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Min Order Value</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.minOrderMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-order-value")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-order-value"
                    >
                      View Order Values
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-order-value")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-order-value"
                    >
                      Add Order Value
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/user-pages")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <div
                className={
                  this.state.taxRateMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("taxRateMenuOpen")}
                data-toggle="collapse"
              >
                <Percent className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Tax Rate</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.taxRateMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-tax-rate")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-tax-rate"
                    >
                      <Trans>View Tax Rate</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-tax-rate")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-tax-rate"
                    >
                      <Trans>Add Tax Rate</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/app-settings")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link className="nav-link" to="/app-settings">
                <Settings className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>App Settings</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/activity-logs")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link className="nav-link" to="/activity-logs">
                <Activity className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Activity Logs</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/automations")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link className="nav-link" to="/automations">
                <Zap className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Automations</Trans>
                </span>
              </Link>
            </li>
          </ul>
        )}

        {JSON.parse(this.props?.cookies?.cookies.user || data)?.role ===
          "producer" && (
          <ul className="nav">
            <li
              className={
                this.isPathActive("/dashboard") ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/dashboard">
                <Grid className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Dashboard</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/sales") ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/sales">
                <BarChart2 className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Sales</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/deliveries")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link className="nav-link" to="/view-deliveries">
                <Truck className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Deliveries</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/sessions") ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/view-sessions">
                <Calendar className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Session Managment</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/basic-ui") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.regionMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("regionMenuOpen")}
                data-toggle="collapse"
              >
                <Globe className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Region</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.regionMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-region")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-region"
                    >
                      <Trans>Region</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-new-region")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-new-region"
                    >
                      <Trans>Add new Region</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/basic-ui") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.locationMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("locationMenuOpen")}
                data-toggle="collapse"
              >
                <MapPin className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Location</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.locationMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-location")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-location"
                    >
                      <Trans>Location</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-new-location")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-new-location"
                    >
                      <Trans>Add new Location</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/tables") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.productsMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("productsMenuOpen")}
                data-toggle="collapse"
              >
                <Package className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Products</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.productsMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-product")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-product"
                    >
                      <Trans>View Products</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-product")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-product"
                    >
                      <Trans>Add New Products</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/tables") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.productsRegionMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("productsRegionMenuOpen")}
                data-toggle="collapse"
              >
                <Map className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Products in Region</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.productsRegionMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("view-productIn-region")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-productIn-region"
                    >
                      <Trans>View Products</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-productIn-region")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-productIn-region"
                    >
                      <Trans>Add New Products</Trans>
                    </Link>
                  </li>{" "}
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/agents") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.agentsMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("agentsMenuOpen")}
                data-toggle="collapse"
              >
                <UserCheck className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Agents</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.agentsMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-agents")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-agents"
                    >
                      <Trans>View Agents</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-agents")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-agents"
                    >
                      <Trans>Add New Agents</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/tables") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.offersMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("offersMenuOpen")}
                data-toggle="collapse"
              >
                <Gift className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Offer</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.offersMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("view-offer")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-offer"
                    >
                      <Trans>View Offers</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-offer")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-offer"
                    >
                      <Trans>Add New Offer</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/coupon-codes")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/coupon-codes"
                    >
                      <Trans>Coupon Codes</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-product-samples")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-product-samples"
                    >
                      <Trans>Tasting Samples</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/icons") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.routessMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("routessMenuOpen")}
                data-toggle="collapse"
              >
                <Navigation className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Routes</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.routessMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-delivery-day")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-delivery-day"
                    >
                      View Routes
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("add-delivery-day")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-delivery-day"
                    >
                      Add new Delivery Day
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-holidays")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-holidays"
                    >
                      Holidays
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/icons") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.ordersMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("ordersMenuOpen")}
                data-toggle="collapse"
              >
                <ShoppingCart className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Order</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.ordersMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-order")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-order"
                    >
                      View Order
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/icons") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.reportsMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("reportsMenuOpen")}
                data-toggle="collapse"
              >
                <BarChart2 className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Reports</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.reportsMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-report")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-report"
                    >
                      View Report
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/picking-list-history")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/picking-list-history"
                    >
                      Picking List History
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/charts") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.customersMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("customersMenuOpen")}
                data-toggle="collapse"
              >
                <Users className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Customers</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.customersMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-customers")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-customers"
                    >
                      View Customer
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/customer-sales")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/customer-sales"
                    >
                      Customer Sales
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/customer-purchase-pattern")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/customer-purchase-pattern"
                    >
                      <Trans>Purchase Pattern</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
          </ul>
        )}

        {JSON.parse(this.props?.cookies?.cookies.user || data)?.role ===
          "agent" && (
          <ul className="nav">
            <li
              className={
                this.isPathActive("/dashboard") ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/dashboard">
                <Grid className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Dashboard</Trans>
                </span>
              </Link>
            </li>
            <li
              className={
                this.isPathActive("/notifications")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <div
                className={
                  this.state.notificationsMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("notificationsMenuOpen")}
                data-toggle="collapse"
              >
                <Bell className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Notifications</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.notificationsMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-notifications")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-notifications"
                    >
                      add Notifications
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/add-notifications")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/add-whatsapp"
                    >
                      Send Whatsapp
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/view-notifications")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/view-notifications"
                    >
                      View Notifications
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
            <li
              className={
                this.isPathActive("/contact") ? "nav-item active" : "nav-item"
              }
            >
              <div
                className={
                  this.state.contactMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("contactMenuOpen")}
                data-toggle="collapse"
              >
                <MessageCircle className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Contact us</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.contactMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/whatsapp-customers")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/whatsapp-customers"
                    >
                      Whatsapp
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/sales-whatsapp")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/sales-whatsapp"
                    >
                      Sales Whatsapp
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/feedbacks")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/feedbacks"
                    >
                      Feedback
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/contact-customers")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/contact-customers"
                    >
                      Contact
                    </Link>
                  </li>
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/issues")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/issues"
                    >
                      Issues
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
          </ul>
        )}

        {JSON.parse(this.props?.cookies?.cookies.user || data)?.role ===
          "warehouse_manager" && (
          <ul className="nav">
            <li
              className={
                this.isPathActive("/warehouse-manager")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link className="nav-link" to="/warehouse-manager">
                <Grid className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Dashboard</Trans>
                </span>
              </Link>
            </li>

            <li
              className={
                this.isPathActive("/view-report") ||
                this.isPathActive("/picking-list-history")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <div
                className={
                  this.state.ReportsMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("ReportsMenuOpen")}
                data-toggle="collapse"
              >
                <BarChart2 className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Reports</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.ReportsMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    {" "}
                    <Link
                      className={
                        this.isPathActive("/picking-list-history")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/picking-list-history"
                    >
                      Picking List History
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>

            <li
              className={
                this.isPathActive("/product-import-export") ||
                this.isPathActive("/product-import-staging")
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <div
                className={
                  this.state.productsMenuOpen
                    ? "nav-link menu-expanded"
                    : "nav-link"
                }
                onClick={() => this.toggleMenuState("productsMenuOpen")}
                data-toggle="collapse"
              >
                <Package className="menu-icon" size={18} />
                <span className="menu-title">
                  <Trans>Products</Trans>
                </span>
                <i className="menu-arrow"></i>
              </div>
              <Collapse in={this.state.productsMenuOpen}>
                <ul className="nav flex-column sub-menu">
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/product-import-export")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/product-import-export"
                    >
                      <Trans>Import / Export</Trans>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={
                        this.isPathActive("/product-import-staging")
                          ? "nav-link active"
                          : "nav-link"
                      }
                      to="/product-import-staging"
                    >
                      <Trans>Imported Products (Staging)</Trans>
                    </Link>
                  </li>
                </ul>
              </Collapse>
            </li>
          </ul>
        )}
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {
    this.onRouteChanged();
    // add className 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector("body");
    document.querySelectorAll(".sidebar .nav-item").forEach((el) => {
      el.addEventListener("mouseover", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      });
      el.addEventListener("mouseout", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      });
    });
  }
}

export default withCookies(withRouter(Sidebar));
